import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubble6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBubble6"><Path d="M7.75 3C4.57436 3 2 5.57436 2 8.75V21H16.25C19.4256 21 22 18.4256 22 15.25V8.75C22 5.57436 19.4256 3 16.25 3H7.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubble6;
